import * as React from "react";
import Chart from "react-apexcharts";
import { getDashboard } from "../services";
import { notify } from "../components/actions/CommonActions";
import {
  PiCaretDownFill,
  PiCaretUpFill,
  PiCheckCircleFill,
  PiWarningFill,
} from "react-icons/pi";
import { FaLock, FaLockOpen } from "react-icons/fa";

const Dashboard = ({ history }) => {
  const [loading, setLoading] = React.useState(false);
  const [dataGotten, setDataGotten] = React.useState(null);
  const [ticketCategories, setTicketCategories] = React.useState(null);

  const numberFormat = (value, toFixed = 2) => {
    const num = Number(value);
    if (Number.isInteger(num)) {
      return num.toLocaleString(); // Handles integer values without decimals
    } else {
      return num
        .toFixed(toFixed) // Ensures the specified number of decimal places
        .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Adds commas for thousands
    }
  };

  React.useEffect(() => {
    const initiate = async () => {
      setLoading(true);
      await getDashboard()
        .then((res) => {
          // console.log('res ', res);
          setDataGotten(res?.data);
        })
        .catch((error) => {
          notify("danger", "OOPS", error?.response?.data?.message);
          console.log('error ', error);
        });
      setLoading(false);
    };
    initiate();
  }, []);

  React.useEffect(() => {
    if (dataGotten) {
      const labels = ["NAICOM", "NIID"];
      const naicom = dataGotten.uploadedToNaicom ?? 0;
      const niid = dataGotten.uploadedToNiid ?? 0;
      const series = [naicom, niid];

      const options = {
        series,
        options: {
          chart: {
            type: "donut",
          },
          stroke: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: true,
            horizontalAlign: "center",
            position: "bottom",
            floating: false,
            formatter: (val, opt) => {
              return `${val} - ${opt?.w?.globals?.series[opt?.seriesIndex]}`;
            },
            markers: {
              width: 8,
              height: 8,
            },
          },
          plotOptions: {
            pie: {
              donut: {
                size: "75%",
                labels: {
                  show: true,
                  value: {
                    fontFamily: "Poppins,sans-serif",
                    fontWeight: 700,
                    offsetY: 0,
                  },
                  total: {
                    showAlways: true,
                    show: true,
                    label: "TOTAL",
                    color: "#000",
                    fontSize: "10px",
                    fontFamily: "Poppins,sans-serif",
                    fontWeight: 600,
                    // formatter: function (w) {
                    //   const val = w.globals.seriesTotals.reduce((a, b) => {
                    //     return a + b;
                    //   }, 0);
                    //   return val;
                    // },
                     formatter: () => numberFormat(dataGotten?.policyCount || 0),
                  },
                },
              },
            },
          },
          labels,
          colors: ["#85c6fb", "#0c4a6e"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      };

      setTicketCategories(options);
    }
  }, [dataGotten]);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center flex-1">
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        <>
          <div className="stat-grid">
            <div className="stat-card">
              <div>
                <div className="stat-card__label">Policy count</div>
                <div className="stat-card__value">
                  {numberFormat(dataGotten?.policyCount || 0)}
                </div>
              </div>
              <div className="stat-card__icon">
                <PiCheckCircleFill />
              </div>
            </div>

            <div className="stat-card">
              <div>
                <div className="stat-card__label">Uploaded to NAICOM</div>
                <div className="stat-card__value">
                  {numberFormat(dataGotten?.uploadedToNaicom || 0)}
                </div>
              </div>
              <div className="stat-card__icon">
                <PiCheckCircleFill />
              </div>
            </div>

            <div className="stat-card">
              <div>
                <div className="stat-card__label">Uploaded to NIID</div>
                <div className="stat-card__value">
                  {numberFormat(dataGotten?.uploadedToNiid || 0)}
                </div>
              </div>
              <div className="stat-card__icon">
                <PiWarningFill />
              </div>
            </div>
          </div>

          <div className="surface-card surface-card--flush mt-4">
            <div className="surface-card__header">
              <div>
                <div className="surface-card__title">
                  Uploaded files distribution
                </div>
                <div className="surface-card__meta">
                  How the policies are spread across the two regulators
                </div>
              </div>
            </div>
            <div className="chart-card">
              {ticketCategories && (
                <Chart
                  options={ticketCategories.options}
                  series={ticketCategories.series}
                  type="donut"
                  height={300}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Dashboard;
